import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Loader2, FilePenLine } from 'lucide-react';
import constant from '../../constant';

const ItemDetails = () => {
    const { itemId } = useParams();
    const navigate = useNavigate();
    const [item, setItem] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const userRole = localStorage.getItem("role");

    useEffect(() => {
        const fetchItemDetails = async () => {
            try {
                const token = localStorage.getItem('token');
                if (!token) {
                    alert('No authentication token found');
                    navigate('/login');
                    return;
                }

                const response = await fetch(`${constant.REACT_APP_API_URL}/item/${itemId}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                });

                if (!response.ok) {
                    throw new Error('Failed to fetch item details');
                }

                const result = await response.json();

                setItem(result.data[0]);
            } catch (error) {
                setError(error.message || 'An error occurred');
            } finally {
                setLoading(false);
            }
        };

        fetchItemDetails();
    }, [itemId, navigate]);

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <Loader2 className="h-12 w-12 animate-spin text-blue-600" />
            </div>
        );
    }

    if (error) {
        return <div className="text-center py-10 text-red-500">{error}</div>;
    }

    return (
        <div className="min-h-screen bg-gray-100 py-10 pt-20 md:pt-10">
            <div className="max-w-4xl mx-auto p-6 bg-white rounded-xl shadow-lg">

                <div className="flex justify-between items-center mb-6 border-b border-gray-200 pb-4">
                    <div className="flex items-center space-x-3">
                        <button onClick={() => navigate('/items')} className="text-gray-500 hover:text-gray-700 transition-colors mr-4">
                            <ArrowLeft className="h-6 w-6" />
                        </button>
                        {/* <h2 className="text-2xl font-semibold text-gray-800">Item Details</h2> */}

                    </div>
                    {userRole === 'admin' ? (
                                        ''
                                    ) : (
                                        <button onClick={() => navigate(`/items/edit/${itemId}`)} className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-md transition-colors duration-150">
                                        <FilePenLine size={18} className="mr-2" />
                                        Edit
                                    </button>
                                    )}
                </div>

                {/* Item Details */}
                <div className="space-y-5 bg-gray-50 p-6 rounded-lg">
                    {/* Item Name */}
                    <div className="flex justify-between items-center py-1">
                        <h3 className="text-lg font-medium text-gray-700">Name</h3>
                        <p className="text-gray-600">{item?.name}</p>
                    </div>

                    {/* GST Rate */}
                    <div className="flex justify-between items-center py-1">
                        <h3 className="text-lg font-medium text-gray-700">GST Rate</h3>
                        <p className="text-gray-600">{item?.gstRate}%</p>
                    </div>

                    {/* Price */}
                    <div className="flex justify-between items-center py-1">
                        <h3 className="text-lg font-medium text-gray-700">Price</h3>
                        <p className="text-gray-600">₹{item?.price}</p>
                    </div>

                    {/* Item Type */}
                    <div className="flex justify-between items-center py-1">
                        <h3 className="text-lg font-medium text-gray-700">Item Type</h3>
                        <p className="text-gray-600">{item?.itemType}</p>
                    </div>


                    {/* HSN Code */}
                    <div className="flex justify-between items-center py-1">
                        <h3 className="text-lg font-medium text-gray-700">HSN/SCN Code</h3>
                        <p className="text-gray-600">{item?.hsnCode}</p>
                    </div>

                    {/* Unit */}
                    <div className="flex justify-between items-center py-1">
                        <h3 className="text-lg font-medium text-gray-700">Unit</h3>
                        <p className="text-gray-600">{item?.unit}</p>
                    </div>

                    {/* Status */}
                    <div className="flex justify-between items-center py-1">
                        <h3 className="text-lg font-medium text-gray-700">Status</h3>
                        <span
                            className={`px-3 py-1 rounded-full text-sm font-medium ${item?.isActive ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`}
                        >
                            {item?.isActive ? 'Active' : 'Inactive'}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ItemDetails;
